/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserDetails} from '../models/UserDetails';

export interface GetUserDetails$Request {
    userId: number;
}

export interface GetUserDetails$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserDetailsRequest = createAction<PayloadData<void, GetUserDetails$Request>>('GET_USER_DETAILS__GET_USER_DETAILS__REQUEST');
export const getUserDetailsSuccess = createAction<PayloadData<UserDetails, GetUserDetails$Request>>('GET_USER_DETAILS__GET_USER_DETAILS__SUCCESS');
export const getUserDetailsFailure = createAction<PayloadData<Error, GetUserDetails$Request, true>>('GET_USER_DETAILS__GET_USER_DETAILS__FAILURE');

export const getUserDetailsActions = [
    getUserDetailsRequest,
    getUserDetailsSuccess,
    getUserDetailsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserDetails = (meta: GetUserDetails$Request, config?: GetUserDetails$Config) => {
    return {
        CALL_API: {
            types: getUserDetailsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

